import { render, staticRenderFns } from "./grigliaPartecipanti.vue?vue&type=template&id=62456b78&"
import script from "./grigliaPartecipanti.vue.ts?vue&type=script&lang=ts&"
export * from "./grigliaPartecipanti.vue.ts?vue&type=script&lang=ts&"
import style0 from "./grigliaPartecipanti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports